import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Button, Card, Modal, Dropdown } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import {
  BsFunnelFill,
  BsSearch,
  BsArrowClockwise,
  BsCreditCard,
  BsCashCoin,
  BsXCircle,
  BsBell,
  BsThreeDotsVertical,
  BsTrashFill,
} from 'react-icons/bs'
import {
  LuGraduationCap,
} from 'react-icons/lu'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import axios, { all } from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

export default function FeesCollection() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(true)
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    const userLogged = Cookies.get('user')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        setUserRole(JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const { course_id, student_id } = useParams()
  const numericStudentId = student_id ? Number(student_id) : null

  useEffect(() => {
    console.log('Course ID:', course_id)
    console.log('Numeric Student ID:', numericStudentId)
  }, [])

  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [currentStudent, setCurrentStudent] = useState(null)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [selectedFee, setSelectedFee] = useState(null)
  const [selectedFeeIds, setSelectedFeeIds] = useState([])
  const [feesToCancelIds, setFeesToCancelIds] = useState([])
  const [isCancelling, setIsCancelling] = useState(false)
  const [openMultiplePayment, setOpenMultiplePayment] = useState(false)
  const [isSubmittingMultiple, setIsSubmittingMultiple] = useState(false)
  const [multiplePaymentData, setMultiplePaymentData] = useState({
    transaction_id: '',
    transaction_amount: '',
    transaction_date: '',
    fees_taken_by: '1',
    payment_method: '',
    discount: '',
    online: '',
    cash: '',
  })
  const [loading, setLoading] = useState(false)
  // const [stid, setStId] = useState(null)
  const [feeStructure, setFeeStructure] = useState([])
  const [open, setOpen] = useState(false)
  const [openPayment, setOpenPayment] = useState(false)
  const [courseNameIs, setCourseNameIs] = useState('')
  const [selectedStudentName, setSelectedStudentName] = useState(null)
  const [
    selectedStudentNameByParams,
    setSelectedStudentNameByParams,
  ] = useState(null)

  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [selectedStudentObj, setSelectedStudentObj] = useState(null)
  const [paymentData, setPaymentData] = useState({
    transaction_id: '',
    transaction_amount: '',
    transaction_date: '',
    fees_taken_by: '1',
    payment_method: '',
    discount: '',
    online: '',
    cash: '',
  })

  const [selectedCourse, setSelectedCourse] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  useEffect(() => {
    console.log('useEffect triggered with:', {
      course_id,
      student_id,
      allStudentsLength: allStudents.length,
      coursesLength: courses.length,
    })

    if (!course_id && allStudents.length > 0) {
      const student = allStudents.find((s) => s.id === Number(student_id))
      if (student) {
        console.log('Student (profile view):', student?.name)
        setSelectedStudentNameByParams(student)
        setSelectedStudent(student?.id)
        setCurrentStudent(student)
        setOpen(true)

        ApiEndpoints.getAllFeesByStudentProfileId(student_id).then((res) => {
          const fees = res.data.data || []
          const pendingFees = fees.filter(
            (fee) =>
              fee.fees_status !== 'complete' && fee.fees_status !== 'cancel',
          )
          console.log('Pending fees (profile):', pendingFees)
          setFeeStructure(pendingFees)
          setSelectedFeeIds([])
        })
      }

      return // prevent running the other block
    }

    if (
      course_id &&
      student_id &&
      allStudents.length > 0 &&
      courses.length > 0
    ) {
      console.log('Setting selected course:', course_id)
      setSelectedCourse(course_id)

      // Fetch classes for this course
      ApiEndpoints.getAllClassesByCourseId(course_id).then((res) => {
        const fetchedClasses = res.data.data || []
        console.log('Fetched classes:', fetchedClasses)
        setClasses(fetchedClasses)

        const student = allStudents.find((s) => s.id === Number(student_id))
        console.log('Found student:', student)

        if (student) {
          const matchedClass = fetchedClasses.find(
            (cls) => cls.id === student.class_id,
          )
          console.log('Matched class for student:', matchedClass)

          if (matchedClass) {
            setSelectedClass(matchedClass.id)
            const filtered = allStudents.filter(
              (s) => s.class_id === matchedClass.id,
            )
            console.log('Filtered students for matched class:', filtered)
            setFilteredStudents(filtered)
            console.log('STUDENT BY PARAMS:', student?.name)

            setSelectedStudentNameByParams(student)
            setSelectedStudent(student?.id)
            setCurrentStudent(student)

            setOpen(true)

            ApiEndpoints.getAllFeesByStudentId(student_id, course_id).then(
              (res) => {
                const pendingFees = res.data.data.filter(
                  (fee) =>
                    fee.fees_status !== 'complete' &&
                    fee.fees_status !== 'cancel',
                )
                console.log('Pending fees:', pendingFees)
                setFeeStructure(pendingFees)
                setSelectedFeeIds([])
              },
            )
          }
        }
      })
    }
  }, [course_id, student_id, allStudents, courses])

  useEffect(() => {
    // If there are no route params, reset everything
    if (!course_id && !student_id) {
      setSelectedCourse('')
      setSelectedClass('')
      setSelectedStudent(null)
      setFilteredStudents([])
      setFeeStructure([])
      setSelectedFeeIds([])
      setOpen(false) // Close data table
    }
  }, [course_id, student_id])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => {
        console.log('Courses:', res.data.data)
        setCourses(res.data.data)
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    const courseName = allStudents.forEach((st) => {
      const course = courses.find((cs) => cs.id === st.course_id)
      const existCourse = course?.name || ''
      console.log(`Student: ${st.name}, Course: ${existCourse}`)
      setCourseNameIs(existCourse)
    })
    console.log('Course Name:', courseName)
  }, [allStudents, courses])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        // setData(response.data.data)
        setAllStudents(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  const handleCourseChange = async (e) => {
    const courseId = e.target.value
    const selected = courses.find((course) => course._id === courseId)
    setSelectedCourse(selected || {})
    setSelectedCourse(courseId)
    setClasses([])
    setFilteredStudents([])
    // if (courseId) {
    //   const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
    //   setClasses(res.data.data)
    // }
    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            console.error('No classes found for this course.')
            setClasses([])
          } else {
            setClasses(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setSelectedClass(classId)
    const filtered = allStudents.filter(
      (student) => student.class_id === Number(classId),
    )
    setFilteredStudents(filtered)

    if (classId) {
      const institueId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null
      if (userCookie) {
        try {
          token = JSON.parse(userCookie)?.token || null
        } catch (err) {
          console.error('Failed to parse user cookie', err)
        }
      }
      const headers = {
        'institute-Id': Number(institueId),
        Authorization: token ? `Bearer ${token}` : undefined,
      }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('Students after class select:', res.data.data)
          setFilteredStudents(res.data.data)
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  // const handleStudentChange = async (e) => {
  //   const studentId = Number(e.target.value)
  //   const student = filteredStudents.find((s) => s.id === studentId)
  //   console.log('STUDENT SELECTED:', student)
  //   console.log('STUDENT NAME:', student.name)
  //   setSelectedStudentName(student?.name)
  //   setSelectedStudentObj(student)
  //   // setSelectedStudent(student)
  //   setSelectedStudent(studentId)

  //   setFeeStructure([])
  //   console.log('Student: ', student)
  //   setOpen(true)

  //   try {
  //     const res = await ApiEndpoints.getAllFeesByStudentId(studentId)
  //     console.log('last response:', res.data.data)
  //     setFeeStructure(res.data.data)
  //     const pendingFees = res.data.data.filter(
  //       (fee) => fee.fees_status == 'pending',
  //     )
  //     console.log('PENDING FEES:', pendingFees)
  //     setFeeStructure(pendingFees)
  //   } catch (error) {
  //     console.error(error.response?.data?.message)
  //   }
  // }

  const handleStudentChange = async (e) => {
    const studentId = Number(e.target.value)
    const student = filteredStudents.find((s) => s.id === studentId)

    if (!student) {
      console.warn('⚠️ Student not found for ID:', studentId)
      setSelectedStudent('')
      setSelectedStudentObj(null)
      setSelectedStudentName('')
      return
    }

    console.log('STUDENT SELECTED:', student)
    console.log('STUDENT NAME:', student.name)

    setSelectedStudentName(student.name)
    setSelectedStudentObj(student)
    setSelectedStudent(studentId)

    setFeeStructure([])
    setSelectedFeeIds([])
    setOpen(true)

    try {
      const res = await ApiEndpoints.getAllFeesByStudentId(
        studentId,
        selectedCourse,
      )
      console.log('last response:', res.data.data)
      const pendingFees = res.data.data.filter(
        (fee) => fee.fees_status === 'pending',
      )
      console.log('PENDING FEES:', pendingFees)
      setFeeStructure(pendingFees)
    } catch (error) {
      console.error(error.response?.data?.message)
    }
  }

  const inputHandler = (e) => {
    const { name, value } = e.target // Correct way to extract name and value
    setPaymentData((prevData) => ({
      ...prevData,
      [name]: value, // Dynamically updating the state field
    }))
    console.log('name', name, 'value', value)
  }

  const handlePay = async () => {
    if (!paymentData.payment_method) {
      toast.error('Please select a payment method')
      return
    }
    if (paymentData.payment_method === 'split') {
      const onlineAmt = Number(paymentData.online) || 0
      const cashAmt = Number(paymentData.cash) || 0
      const total = Number(paymentData.transaction_amount) || 0

      if (onlineAmt <= 0 && cashAmt <= 0) {
        toast.error('Please enter Online/Cash amount')
        return
      }
      // if (onlineAmt + cashAmt !== total) {
      //   toast.error('Online + Cash must equal Transaction Amount')
      //   return
      // }
    }
    // const finalStudentId =
    //   selectedStudent ||
    //   selectedStudent.id ||
    //   feeStructure ||
    //   feeStructure.student_id // Adjust if structure differs

    // const finalStudentId = selectedStudent?.id || feeStructure
    const finalStudentId =
      typeof selectedStudent === 'object' && selectedStudent !== null
        ? selectedStudent.id
        : typeof selectedStudent === 'string' ||
          typeof selectedStudent === 'number'
        ? selectedStudent
        : typeof feeStructure === 'object' && feeStructure !== null
        ? feeStructure.student_id || feeStructure.id
        : typeof feeStructure === 'string' || typeof feeStructure === 'number'
        ? feeStructure
        : null

    if (!finalStudentId) {
      toast.error('Student ID is missing or invalid')
      return
    }

    const formattedDate = paymentData.transaction_date
      ? new Date(paymentData.transaction_date)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')
      : null
    try {
      const payload = {
        student_id: finalStudentId,
        fee_id: selectedFee.id,
        transaction_id: paymentData.transaction_id,
        transaction_amount: paymentData.transaction_amount,
        transaction_date: formattedDate,
        fees_taken_by: paymentData.fees_taken_by,
        payment_method: paymentData.payment_method,
        // discount: paymentData.discount || '0',
        discount: Number(paymentData.discount) || 0,
      }
      if (paymentData.payment_method === 'split') {
        payload.online = Number(paymentData.online) || 0
        payload.cash = Number(paymentData.cash) || 0
      }
      console.log('Payload', payload)
      const submittedFeeId = selectedFee.id

      try {
        const response = await ApiEndpoints.submitStudentFee(payload)
        toast.success(
          response.data?.result || response.data?.message || 'Payment successful',
        )
      } catch (error) {
        toast.error(
          error.response?.data?.result ||
            error.response?.data?.message ||
            'Payment failed',
        )
        return
      }

      try {
        const userCookie = Cookies.get('user')
        const parsedUser = userCookie ? JSON.parse(userCookie) : null
        const token = parsedUser?.token
        const instituteId = Cookies.get('institute_id')

        const whatsappResponse = await axios.post(
          `${BASE_URL}/fees/send-receipt-whatsapp`,
          { fee_id: Number(submittedFeeId) },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              Accept: 'application/json',
              ...(instituteId ? { 'institute-Id': Number(instituteId) } : {}),
            },
          },
        )
        toast.success(
          whatsappResponse.data?.message ||
            'Fee receipt sent on WhatsApp successfully',
        )
      } catch (whatsappError) {
        toast.error(
          whatsappError.response?.data?.message ||
            'Failed to send fee receipt on WhatsApp',
        )
      }

      setFeeStructure((prevFees) =>
        prevFees.filter((fee) => fee.id !== submittedFeeId),
      )

      setOpenPayment(false)
      setPaymentData({
        transaction_id: '',
        transaction_amount: '',
        transaction_date: '',
        fees_taken_by: '1',
        discount: '',
        online: '',
        cash: '',
      })
      setSelectedFee(null)
      // setTimeout(() => {
      //   window.location.reload()
      // }, 1000)
    } catch (error) {
      toast.error(error.response?.data?.result || 'Payment failed')
    }
  }
  const handleTakeFees = (feeItem) => {
    const today = new Date().toISOString().split('T')[0] // Format: YYYY-MM-DD

    setSelectedFee(feeItem)
    setPaymentData({
      transaction_id: '',
      transaction_amount: feeItem.amount,
      payment_method: '',
      transaction_date: today,
      fees_taken_by: '1',
      discount: feeItem.discount || '',
      online: '',
      cash: '',
      fees_name: feeItem.fees_name,
    })
    setOpenPayment(true)
  }

  const [blinkColor, setBlinkColor] = useState('red')

  useEffect(() => {
    const interval = setInterval(() => {
      setBlinkColor((prevColor) => (prevColor === 'red' ? 'blue' : 'red'))
    }, 500)

    return () => clearInterval(interval) // cleanup
  }, [])

  const handleSendRemider = async (feeItem) => {
    const user = Cookies.get('user')
    console.log('Token:', user)
    const parsedUser = user ? JSON.parse(user) : null
    const token = parsedUser?.token
    const payload = {
      student_id: feeItem.student_id,
      fee_id: feeItem.id,
    }
    console.log('Payload during send reminder:', payload)
    try {
      const response = await axios.post(
        BASE_URL+'/send-fee-reminder',
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )
      const data = response.data
      if (data?.result === 'Error' || data?.result === 'error') {
        toast.error(data?.message || 'Failed to send reminder')
        return
      }
      toast.success(data?.message || data?.result)
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.result ||
          'Failed to send reminder',
      )
    }
  }

  const handleRefresh = () => {
    setCourses([])
    setClasses([])
    setFilteredStudents([])
    setFeeStructure([])
    setSelectedFeeIds([])
    setSelectedStudent(null)
    setSelectedFee(null)
    setSelectedCourse([])
    setOpen(false)
    setCurrentStudent(null)
    navigate('/TakeFees')
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch(console.error)

    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
      } catch (err) {
        console.error('Failed to parse user cookie', err)
      }
    }

    const fetchFilteredData = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        setAllStudents(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }

  const handleSelectFee = (feeId) => {
    setSelectedFeeIds((prev) =>
      prev.includes(feeId)
        ? prev.filter((id) => id !== feeId)
        : [...prev, feeId],
    )
  }

  const handleSelectAllFees = () => {
    if (selectedFeeIds.length === feeStructure.length) {
      setSelectedFeeIds([])
    } else {
      setSelectedFeeIds(feeStructure.map((fee) => fee.id))
    }
  }

  const openCancelModal = (feeIds) => {
    if (!feeIds.length) return
    setFeesToCancelIds(feeIds)
    setShowCancelModal(true)
  }

  const handleConfirmCancel = async () => {
    if (!feesToCancelIds.length) return
    setIsCancelling(true)
    const userCookie = Cookies.get('user')
    let token = null

    try {
      const user = JSON.parse(userCookie)
      token = user.token

      const response = await axios.post(
        `${BASE_URL}/cancel-fee`,
        { fee_ids: feesToCancelIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      )

      const cancelledIds = response.data?.cancelled_ids || feesToCancelIds
      toast.success(response.data?.message || 'Fee cancelled successfully')
      setShowCancelModal(false)
      setFeeStructure((prev) =>
        prev.filter((fee) => !cancelledIds.includes(fee.id)),
      )
      setSelectedFeeIds((prev) =>
        prev.filter((id) => !cancelledIds.includes(id)),
      )
      setFeesToCancelIds([])
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to cancel fee')
    } finally {
      setIsCancelling(false)
    }
  }

  const feesToCancelDetails = feeStructure.filter((fee) =>
    feesToCancelIds.includes(fee.id),
  )

  const selectedFeesForMultiple = feeStructure.filter((fee) =>
    selectedFeeIds.includes(fee.id),
  )

  const multiplePaymentInputHandler = (e) => {
    const { name, value } = e.target
    setMultiplePaymentData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleOpenTakeMultipleFees = () => {
    if (selectedFeeIds.length === 0) return

    const now = new Date()
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      '0',
    )}-${String(now.getDate()).padStart(2, '0')}`
    const totalAmount = selectedFeesForMultiple.reduce(
      (sum, fee) => sum + (Number(fee.amount) || 0),
      0,
    )
    const totalDiscount = selectedFeesForMultiple.reduce(
      (sum, fee) => sum + (Number(fee.discount) || 0),
      0,
    )

    setMultiplePaymentData({
      transaction_id: '',
      transaction_amount: totalAmount,
      payment_method: '',
      transaction_date: today,
      fees_taken_by: '1',
      discount: totalDiscount || '',
      online: '',
      cash: '',
    })
    setOpenMultiplePayment(true)
  }

  const handlePayMultiple = async () => {
    if (!multiplePaymentData.payment_method) {
      toast.error('Please select a payment method')
      return
    }
    if (multiplePaymentData.payment_method === 'split') {
      const onlineAmt = Number(multiplePaymentData.online) || 0
      const cashAmt = Number(multiplePaymentData.cash) || 0

      if (onlineAmt <= 0 && cashAmt <= 0) {
        toast.error('Please enter Online/Cash amount')
        return
      }
    }

    const finalStudentId =
      typeof selectedStudent === 'object' && selectedStudent !== null
        ? selectedStudent.id
        : typeof selectedStudent === 'string' ||
          typeof selectedStudent === 'number'
        ? selectedStudent
        : typeof feeStructure === 'object' && feeStructure !== null
        ? feeStructure.student_id || feeStructure.id
        : typeof feeStructure === 'string' || typeof feeStructure === 'number'
        ? feeStructure
        : null

    if (!finalStudentId) {
      toast.error('Student ID is missing or invalid')
      return
    }

    if (selectedFeeIds.length === 0 || selectedFeesForMultiple.length === 0) {
      toast.error('Please select at least one fee')
      return
    }

    const dateMatch = String(multiplePaymentData.transaction_date || '').match(
      /^(\d{4}-\d{2}-\d{2})/,
    )
    if (!dateMatch) {
      toast.error('Please select a transaction date')
      return
    }
    const now = new Date()
    const pad = (value) => String(value).padStart(2, '0')
    const formattedDate = `${dateMatch[1]} ${pad(now.getHours())}:${pad(
      now.getMinutes(),
    )}:${pad(now.getSeconds())}`

    const toCents = (value) => Math.round((Number(value) || 0) * 100)
    const feeCount = selectedFeesForMultiple.length
    const ownDiscountCents = selectedFeesForMultiple.map((fee) =>
      toCents(fee.discount),
    )
    const ownDiscountSum = ownDiscountCents.reduce((sum, cents) => sum + cents, 0)
    const enteredDiscountCents = toCents(multiplePaymentData.discount)
    let discountCentsList
    if (enteredDiscountCents === ownDiscountSum) {
      discountCentsList = ownDiscountCents
    } else {
      const baseDiscount = Math.floor(enteredDiscountCents / feeCount)
      let discountRemainder = enteredDiscountCents - baseDiscount * feeCount
      discountCentsList = selectedFeesForMultiple.map(() => {
        const extra = discountRemainder > 0 ? 1 : 0
        if (discountRemainder > 0) discountRemainder -= 1
        return baseDiscount + extra
      })
    }

    const studentId = Number(
      selectedFeesForMultiple[0]?.student_id || finalStudentId,
    )
    if (!Number.isFinite(studentId) || studentId <= 0) {
      toast.error('Student ID is missing or invalid')
      return
    }

    let fees
    if (multiplePaymentData.payment_method === 'split') {
      const payableList = selectedFeesForMultiple.map((fee, index) =>
        Math.max(0, toCents(fee.amount) - discountCentsList[index]),
      )
      const totalPayable = payableList.reduce((sum, cents) => sum + cents, 0)
      const cashTotal = toCents(multiplePaymentData.cash)
      const onlineTotal = toCents(multiplePaymentData.online)
      if (cashTotal + onlineTotal !== totalPayable) {
        toast.error('Online + Cash must equal the payable amount after discount')
        return
      }

      let cashLeft = cashTotal
      let onlineLeft = onlineTotal
      fees = selectedFeesForMultiple.map((fee, index) => {
        const payable = payableList[index]
        const isLast = index === feeCount - 1
        const cashCents = isLast
          ? cashLeft
          : Math.min(
              payable,
              totalPayable > 0
                ? Math.round((cashTotal * payable) / totalPayable)
                : 0,
            )
        const onlineCents = isLast ? onlineLeft : payable - cashCents
        if (!isLast) {
          cashLeft -= cashCents
          onlineLeft -= onlineCents
        }
        return {
          fee_id: Number(fee.id),
          cash: cashCents / 100,
          online: onlineCents / 100,
          discount: discountCentsList[index] / 100,
        }
      })
    } else {
      fees = selectedFeesForMultiple.map((fee, index) => ({
        fee_id: Number(fee.id),
        transaction_amount: toCents(fee.amount) / 100,
        discount: discountCentsList[index] / 100,
      }))
    }

    setIsSubmittingMultiple(true)
    try {
      const payload = {
        student_id: studentId,
        payment_method: multiplePaymentData.payment_method,
        transaction_date: formattedDate,
        transaction_id: multiplePaymentData.transaction_id || '',
        fees,
      }

      const response = await ApiEndpoints.submitStudentFees(payload)
      const body = response.data || {}
      const resultText = typeof body.result === 'string' ? body.result.trim() : ''
      const succeeded = /success/i.test(resultText)
      const failed =
        !succeeded ||
        /^error$/i.test(resultText) ||
        /already taken/i.test(resultText)

      if (failed) {
        toast.error(body.message || resultText || 'Payment failed')
        return
      }

      const submittedFeeIds = Array.isArray(body.data)
        ? body.data
            .map((fee) => Number(fee.id))
            .filter((id) => Number.isFinite(id))
        : []
      const idsToRemove = submittedFeeIds.length
        ? submittedFeeIds
        : selectedFeesForMultiple.map((fee) => Number(fee.id))

      setOpenMultiplePayment(false)
      setMultiplePaymentData({
        transaction_id: '',
        transaction_amount: '',
        transaction_date: '',
        fees_taken_by: '1',
        payment_method: '',
        discount: '',
        online: '',
        cash: '',
      })
      setFeeStructure((prevFees) =>
        prevFees.filter((fee) => !idsToRemove.includes(Number(fee.id))),
      )
      setSelectedFeeIds((prev) =>
        prev.filter((id) => !idsToRemove.includes(Number(id))),
      )
      toast.success(resultText || 'Fees submitted successfully')
    } catch (error) {
      const validationErrors = error.response?.data?.errors
      const validationMessage = validationErrors
        ? Object.values(validationErrors).flat().filter(Boolean).join(' ')
        : ''
      toast.error(
        validationMessage ||
          error.response?.data?.message ||
          error.response?.data?.result ||
          'Payment failed',
      )
    } finally {
      setIsSubmittingMultiple(false)
    }
  }

  return (
    <>
      <style>
        {`
          /* Fix Typeahead dropdown visibility - ensure it appears above filter card */
          .take-fees-typeahead {
            position: relative !important;
          }

          .take-fees-typeahead .rbt {
            position: relative !important;
            width: 100% !important;
          }

          .rbt-menu {
            z-index: 2000 !important;
            max-height: 240px !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
            background-color: #ffffff !important;
            border: 1px solid #D1D3D4 !important;
            border-radius: 8px !important;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
            margin-top: 4px !important;
            padding: 4px 0 !important;
          }
          
          .rbt-input-wrapper {
            position: relative !important;
          }

          .rbt .form-control,
          .rbt-input-main,
          .rbt .rbt-input-multi,
          .rbt .rbt-input {
            border-radius: 8px !important;
            border: 1px solid #D1D3D4 !important;
            font-size: 14px !important;
            padding: 8px 12px !important;
            min-height: 42px !important;
            background-color: #ffffff !important;
            color: #111827 !important;
            transition: all 0.2s ease !important;
            font-family: 'Inter', system-ui, sans-serif !important;
          }

          .rbt .rbt-input-multi .rbt-input-wrapper {
            align-items: center !important;
          }

          /* Bootstrap btn-close already draws an X; hide Typeahead's extra × text */
          .take-fees-typeahead .rbt-close-content {
            display: none !important;
          }

          .take-fees-typeahead .rbt-aux .rbt-close {
            opacity: 0.65;
            box-shadow: none;
            background-size: 0.65em;
          }

          .take-fees-typeahead .rbt-aux .rbt-close:hover {
            opacity: 1;
          }

          .rbt-token,
          .rbt .rbt-token {
            background-color: #E8EEF1 !important;
            color: #111827 !important;
            border-radius: 6px !important;
            font-size: 13px !important;
            max-width: 100% !important;
            white-space: normal !important;
            word-break: break-word !important;
          }
          
          .rbt-input-main:focus,
          .rbt .form-control:focus,
          .rbt.focus .rbt-input {
            border-color: #223843 !important;
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(34, 56, 67, 0.12) !important;
          }
          
          .rbt-menu .dropdown-item {
            padding: 10px 12px !important;
            font-size: 14px !important;
            font-family: 'Inter', system-ui, sans-serif !important;
            color: #111827 !important;
            background-color: #ffffff !important;
            cursor: pointer !important;
            white-space: normal !important;
            word-break: break-word !important;
          }
          
          .rbt-menu .dropdown-item:hover,
          .rbt-menu .dropdown-item.active,
          .rbt-menu .dropdown-item:active,
          .rbt-menu .dropdown-item:focus {
            background-color: #F3F4F6 !important;
            color: #111827 !important;
          }
          
          /* Ensure filter card container allows dropdown to overflow */
          .filter-card-container {
            overflow: visible !important;
            position: relative !important;
            z-index: 20 !important;
          }

          /* Mobile stacked selects: upper field menus must sit above lower fields */
          .take-fees-select-course {
            position: relative !important;
            z-index: 30 !important;
          }
          .take-fees-select-class {
            position: relative !important;
            z-index: 20 !important;
          }
          .take-fees-select-student {
            position: relative !important;
            z-index: 10 !important;
          }

          /* Hide dropdown caret */
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }

          /* Ensure dropdown menu appears correctly */
          .table td {
            overflow: visible !important;
          }
          
          .table tbody tr {
            overflow: visible !important;
          }
          
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }

          /* Hide mobile-only Select All on desktop/tablet table view */
          .take-fees-mobile-select-all {
            display: none;
          }

          /* Hide per-card Select column on desktop/tablet */
          .take-fees-table .take-fees-select-col {
            display: none;
          }

          /* Match react-super-responsive-table card breakpoint (40em) */
          @media screen and (max-width: 40em) {
            .take-fees-mobile-select-all {
              display: flex;
              align-items: center;
              gap: 10px;
              background: #ffffff;
              border: 1px solid #D1D3D4;
              border-radius: 8px;
              padding: 8px 14px;
              margin: 0;
              width: fit-content;
              max-width: 100%;
              box-sizing: border-box;
            }
            .take-fees-mobile-select-all input[type="checkbox"] {
              width: 18px;
              height: 18px;
              margin: 0;
              flex-shrink: 0;
              accent-color: #223843;
              cursor: pointer;
            }
            .take-fees-mobile-select-all span {
              font-size: 14px;
              font-weight: 600;
              color: #111827;
              font-family: Inter, system-ui, sans-serif;
              line-height: 1.2;
              white-space: nowrap;
            }
            /* Hide desktop checkbox column so cards don't get a duplicate Select All row */
            .take-fees-table .take-fees-checkbox-col {
              display: none !important;
            }
            .take-fees-table .take-fees-select-col,
            .take-fees-table td.take-fees-select-col.pivoted {
              display: block !important;
              position: relative !important;
              padding: 12px 10px 6px 10px !important;
              padding-left: 10px !important;
              margin-top: 6px;
              border: none !important;
              border-top: 1px solid #E5E7EB !important;
              text-align: left !important;
            }
            .take-fees-table .take-fees-select-col .tdBefore {
              display: none !important;
            }
          }

          @media screen and (min-width: 40.01em) {
            .take-fees-table .take-fees-select-col {
              display: none !important;
            }
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%',
            }}
          >
            {/* Left: Title */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0,
              }}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                Take Fees{currentStudent && ` from ${(currentStudent?.name || selectedStudent?.name)?.charAt(0).toUpperCase() + (currentStudent?.name || selectedStudent?.name)?.slice(1).toLowerCase()}`}
              </h3>
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
          {/* Filter Toggle Button */}
          {!student_id && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="d-flex align-items-center gap-3">
                  <button
                    onClick={() => setShowFilterCard(!showFilterCard)}
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                      border: '1px solid #D1D3D4',
                      color: showFilterCard ? '#ffffff' : '#223843',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                      e.currentTarget.style.color = '#ffffff'
                      e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                      e.currentTarget.style.transform = 'scale(1.05)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                      e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                      e.currentTarget.style.borderColor = '#D1D3D4'
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                    title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
                  >
                    <BsFunnelFill size={20} />
                  </button>
                </div>
              </div>

              {/* Modern Filter Section */}
              <div 
                className="filter-card-container"
                style={{
                  maxHeight: showFilterCard ? 'none' : '0',
                  overflow: showFilterCard ? 'visible' : 'hidden',
                  transition: 'max-height 0.3s ease-in-out',
                  marginBottom: showFilterCard ? '24px' : '0',
                  position: 'relative',
                  zIndex: showFilterCard ? 30 : 1,
                }}
              >
                {showFilterCard && (
                  <Card 
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '12px',
                      backgroundColor: '#ffffff',
                      overflow: 'visible',
                      position: 'relative',
                    }}
                  >
                    {/* Header */}
                    <div 
                      style={{
                        background: '#ffffff',
                        padding: '20px',
                        borderBottom: '1px solid #F3F4F6',
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                          <div 
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              backgroundColor: '#223843',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                          </div>
                          <div>
                            <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                              Select Course, Class & Student
                            </h5>
                            <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                              Choose course, class and student to collect fees
                            </p>
                          </div>
                        </div>
                        <div className="d-flex gap-2">
                          <button
                            onClick={handleRefresh}
                            style={{
                              width: '48px',
                              height: '48px',
                              borderRadius: '50%',
                              backgroundColor: '#223843',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.transform = 'scale(1.05)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Refresh"
                          >
                            <BsArrowClockwise size={20} />
                          </button>
                        </div>
                      </div>
                    </div>

                    <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                      <Row className="g-4 text-start">
                        {/* Course Selection */}
                        <Col xs={12} md={4} className="take-fees-select-course">
                          <div style={{ 
                            padding: '20px', 
                            backgroundColor: '#F3F4F6', 
                            borderRadius: '8px',
                            border: '1px solid #D1D3D4',
                            overflow: 'visible',
                            position: 'relative',
                          }}>
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div 
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%',
                                  backgroundColor: '#10B981',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                              </div>
                              <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Select Course
                              </label>
                            </div>
                            <div className="take-fees-typeahead">
                              <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Course
                              </label>
                              <Typeahead
                                id="course-select"
                                labelKey="name"
                                positionFixed
                                clearButton
                                onChange={(selected) => {
                                  const course = selected[0]
                                  if (course) {
                                    handleCourseChange({ target: { value: course.id } })
                                  } else {
                                    handleCourseChange({ target: { value: '' } })
                                  }
                                }}
                                options={courses}
                                placeholder="Select Course"
                                selected={selectedCourse ? courses.filter(
                                  (cs) => cs.id === Number(selectedCourse),
                                ) : []}
                              />
                            </div>
                          </div>
                        </Col>

                        {/* Class Selection */}
                        <Col xs={12} md={4} className="take-fees-select-class">
                          <div style={{ 
                            padding: '20px', 
                            backgroundColor: '#F3F4F6', 
                            borderRadius: '8px',
                            border: '1px solid #D1D3D4',
                            overflow: 'visible',
                            position: 'relative',
                          }}>
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div 
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%',
                                  backgroundColor: '#10B981',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                              </div>
                              <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Select Class
                              </label>
                            </div>
                            <div className="take-fees-typeahead">
                              <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Class
                              </label>
                              <Typeahead
                                id="class-select"
                                labelKey="class_name"
                                positionFixed
                                clearButton
                                onChange={(selected) => {
                                  const cls = selected[0]
                                  if (cls) {
                                    handleClassChange({ target: { value: cls.id } })
                                  } else {
                                    handleClassChange({ target: { value: '' } })
                                  }
                                }}
                                options={classes}
                                placeholder="Select Class"
                                selected={selectedClass ? classes.filter(
                                  (cs) => cs.id === Number(selectedClass),
                                ) : []}
                              />
                            </div>
                          </div>
                        </Col>

                        {/* Student Selection */}
                        <Col xs={12} md={4} className="take-fees-select-student">
                          <div style={{ 
                            padding: '20px', 
                            backgroundColor: '#F3F4F6', 
                            borderRadius: '8px',
                            border: '1px solid #D1D3D4',
                            overflow: 'visible',
                            position: 'relative',
                          }}>
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div 
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%',
                                  backgroundColor: '#10B981',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                              </div>
                              <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Select Student
                              </label>
                            </div>
                            <div className="take-fees-typeahead">
                              <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Student
                              </label>
                              <Typeahead
                                id="student-select"
                                labelKey={(option) =>
                                  `${option.name} - ${option.admission_number}`
                                }
                                positionFixed
                                clearButton
                                onChange={(selected) => {
                                  const student = selected[0]
                                  if (student) {
                                    handleStudentChange({ target: { value: student.id } })
                                  } else {
                                    handleStudentChange({ target: { value: '' } })
                                  }
                                }}
                                options={filteredStudents}
                                placeholder="Select Student"
                                selected={
                                  selectedStudent
                                    ? filteredStudents.filter(
                                        (st) => st.id === Number(selectedStudent),
                                      )
                                    : []
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}
              </div>
            </>
          )}

          {/* Student Details */}
          {((open && selectedStudent) || (open && numericStudentId)) && (
            <Card 
              style={{
                border: '1px solid #D1D3D4',
                borderRadius: '12px',
                backgroundColor: '#ffffff',
                overflow: 'visible',
                position: 'relative',
                marginTop: '24px',
              }}
            >
              <Card.Body className="p-4">
                <h5 className="fw-semibold mb-4" style={{ color: '#223843', fontSize: '18px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  👨‍🎓 Fees Detail of {selectedStudentNameByParams?.name?.toUpperCase() ||
                    selectedStudentName?.toUpperCase() ||
                    '-'}
                </h5>

                {feeStructure.length > 0 ? (
                  <>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <label
                      htmlFor="take-fees-select-all-mobile"
                      className="take-fees-mobile-select-all"
                      style={{ cursor: 'pointer' }}
                    >
                      <input
                        type="checkbox"
                        id="take-fees-select-all-mobile"
                        checked={
                          feeStructure.length > 0 &&
                          selectedFeeIds.length === feeStructure.length
                        }
                        onChange={handleSelectAllFees}
                      />
                      <span>Select All</span>
                    </label>
                    <div
                      className="d-flex align-items-center flex-wrap gap-2"
                      style={{ marginLeft: 'auto' }}
                    >
                      <Button
                        variant="danger"
                        disabled={selectedFeeIds.length === 0 || isCancelling}
                        onClick={() => openCancelModal(selectedFeeIds)}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        <BsTrashFill size={16} />
                        Cancel Selected
                        {selectedFeeIds.length > 0 && ` (${selectedFeeIds.length})`}
                      </Button>
                      <Button
                        variant="success"
                        disabled={
                          selectedFeeIds.length === 0 || isSubmittingMultiple
                        }
                        onClick={handleOpenTakeMultipleFees}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        <BsCashCoin size={16} />
                        Take Multiple Fees
                        {selectedFeeIds.length > 0 &&
                          ` (${selectedFeeIds.length})`}
                      </Button>
                    </div>
                  </div>
                  <div className="table-container" style={{ overflowX: 'auto', overflowY: 'visible', position: 'relative', borderRadius: '12px' }}>
                    <Table className="table mb-0 take-fees-table" style={{ borderRadius: '12px', overflow: 'visible', position: 'relative' }}>
                    <Thead>
                      <Tr style={{ backgroundColor: '#F3F4F6' }}>
                        <Th className="take-fees-checkbox-col" style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif', width: '50px' }}>
                          <input
                            type="checkbox"
                            checked={feeStructure.length > 0 && selectedFeeIds.length === feeStructure.length}
                            onChange={handleSelectAllFees}
                            style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                            aria-label="Select all fees"
                          />
                        </Th>
                        <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Fee Name</Th>
                        <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Course</Th>
                        <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Amount</Th>
                        <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Start Date</Th>
                        <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>End Date</Th>
                        <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Fees Status</Th>
                        <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
                        <Th className="take-fees-select-col" style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Select</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {feeStructure.map((feeItem, index) => (
                        <Tr 
                          key={index}
                          style={{ 
                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#F3F4F6',
                            transition: 'background-color 0.2s ease',
                            borderBottom: '1px solid #D1D3D4',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#F3F4F6'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#F3F4F6'
                          }}
                        >
                          <Td className="text-center take-fees-checkbox-col" style={{ padding: '16px', border: 'none' }}>
                            <input
                              type="checkbox"
                              checked={selectedFeeIds.includes(feeItem.id)}
                              onChange={() => handleSelectFee(feeItem.id)}
                              style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                              aria-label={`Select fee ${feeItem.fees_name || feeItem.id}`}
                            />
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {feeItem.fees_name.charAt(0).toUpperCase() +
                              feeItem.fees_name.slice(1)}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{feeItem.course_name || courseNameIs}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>₹ {feeItem.amount}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {new Date(feeItem.start_date).toLocaleDateString(
                              'en-GB',
                              {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                              },
                            )}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {new Date(feeItem.end_date).toLocaleDateString(
                              'en-GB',
                              {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                              },
                            )}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {feeItem.fees_status.charAt(0).toUpperCase() +
                              feeItem.fees_status.slice(1)}
                          </Td>
                          <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                            {/* Action Dropdown - icons with text (desktop & mobile) */}
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="light"
                                id={`dropdown-${feeItem.id}`}
                                style={{
                                  width: '36px',
                                  height: '36px',
                                  borderRadius: '50%',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #D1D3D4',
                                  padding: '0',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s ease',
                                }}
                                className="dropdown-toggle-no-caret"
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#223843'
                                  e.currentTarget.style.borderColor = '#223843'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.borderColor = '#D1D3D4'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsThreeDotsVertical style={{ color: 'inherit' }} />
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                align="end"
                                style={{
                                  borderRadius: '8px',
                                  border: '1px solid #D1D3D4',
                                  padding: '8px',
                                  minWidth: '180px',
                                }}
                              >
                                <Dropdown.Item
                                  onClick={() => handleTakeFees(feeItem)}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    transition: 'all 0.2s ease',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#10B981'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color = '#111827'
                                  }}
                                >
                                  <BsCashCoin size={18} /> Take Fees
                                </Dropdown.Item>

                                <Dropdown.Item
                                  onClick={() => openCancelModal([feeItem.id])}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    transition: 'all 0.2s ease',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#EF4444'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color = '#111827'
                                  }}
                                >
                                  <BsXCircle size={18} /> Cancel Fees
                                </Dropdown.Item>

                                <Dropdown.Item
                                  onClick={() => handleSendRemider(feeItem)}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    transition: 'all 0.2s ease',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#F59E0B'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color = '#111827'
                                  }}
                                >
                                  <BsBell size={18} /> Send Reminder
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </Td>
                          <Td className="take-fees-select-col" style={{ fontSize: '14px', padding: '16px', border: 'none', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            <label
                              htmlFor={`take-fees-mobile-select-${feeItem.id}`}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '10px',
                                cursor: 'pointer',
                                margin: 0,
                                minHeight: '44px',
                                userSelect: 'none',
                              }}
                            >
                              <input
                                type="checkbox"
                                id={`take-fees-mobile-select-${feeItem.id}`}
                                checked={selectedFeeIds.includes(feeItem.id)}
                                onChange={() => handleSelectFee(feeItem.id)}
                                style={{
                                  width: '18px',
                                  height: '18px',
                                  margin: 0,
                                  accentColor: '#223843',
                                  cursor: 'pointer',
                                  flexShrink: 0,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: '14px',
                                  fontWeight: '600',
                                  color: '#111827',
                                  fontFamily: 'Inter, system-ui, sans-serif',
                                  lineHeight: 1.2,
                                }}
                              >
                                Select
                              </span>
                            </label>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                  </div>
                  </>
                ) : (
                  <p className="text-danger fw-semibold mt-3" style={{ fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>No Fees Found</p>
                )}
              </Card.Body>
            </Card>
          )}

        <Modal show={openPayment} onHide={() => setOpenPayment(false)} centered>
          <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
            <Modal.Title>💰 Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="g-3">

              <Col xs={12}>
                <div className="mb-1">
                  <strong>Student:</strong>{' '}
                  {selectedStudentNameByParams?.name?.toUpperCase() ||
                    selectedStudentName?.toUpperCase() ||
                    '-'}
                  <ul className="mt-2 mb-0">
                    <li className="fw-semibold">
                      {paymentData?.fees_name?.toUpperCase() || '-'} — ₹{' '}
                      {paymentData?.transaction_amount || 'N/A'}
                    </li>
                  </ul>
                </div>
              </Col>
            
              {/* Transaction ID */}
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Payment Method</Form.Label>
                  <Form.Select
                    name="payment_method"
                    value={paymentData.payment_method}
                    onChange={inputHandler}
                    required
                  >
                    <option value="">Select</option>
                    <option value="cash">Cash</option>
                    <option value="online">Online</option>
                    <option value="cheque">Cheque</option>
                    <option value="split">Split Payment</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Form.Group>
                  <Form.Label>
                    {paymentData.payment_method === 'online'
                      ? 'Transaction ID'
                      : paymentData.payment_method === 'cheque'
                      ? 'Cheque ID'
                      : 'Transaction / Cheque ID'}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={
                      paymentData.payment_method === 'online'
                        ? 'Enter Transaction ID'
                        : paymentData.payment_method === 'cheque'
                        ? 'Enter Cheque ID'
                        : paymentData.payment_method === 'split'
                        ? 'Enter Transaction ID'
                        : 'Select a payment method first'
                    }
                    name="transaction_id"
                    value={paymentData.transaction_id}
                    onChange={inputHandler}
                    disabled={
                      paymentData.payment_method !== 'online' &&
                      paymentData.payment_method !== 'cheque' &&
                      paymentData.payment_method !== 'split'
                    }
                  />
                </Form.Group>
              </Col>

              {/* Transaction Amount */}
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Transaction Amount</Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="Enter Amount"
                    name="transaction_amount"
                    value={paymentData.transaction_amount}
                    onChange={inputHandler}
                    disabled
                  />
                </Form.Group>
              </Col>

              {paymentData.payment_method === 'split' && (
                <>
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label>Enter Online Amount</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        name="online"
                        value={paymentData.online}
                        onChange={inputHandler}
                        placeholder="Enter Online Amount"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label>Enter Cash Amount</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        name="cash"
                        value={paymentData.cash}
                        onChange={inputHandler}
                        placeholder="Enter Cash Amount"
                      />
                    </Form.Group>
                  </Col>
                </>
              )}

              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Discount</Form.Label>
                  <Form.Control
                    type="text"
                    name="discount"
                    value={paymentData.discount}
                    onChange={inputHandler}
                  />
                </Form.Group>
              </Col>
              {/* Transaction Date */}
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Transaction Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="transaction_date"
                    value={paymentData.transaction_date}
                    onChange={inputHandler}
                  />
                </Form.Group>
              </Col>
            </Row>
            <p
              className="fw-bold"
              style={{
                color: blinkColor,
                marginTop: '5px',
                marginBottom: '-5px',
                letterSpacing: '2px',
              }}
            >
              Please ensure to collect money: ₹
              {(() => {
                const total = Number(paymentData.transaction_amount) || 0
                const discount = Number(paymentData.discount) || 0
                const payable = Math.max(
                  0,
                  Math.round((total - discount) * 100) / 100,
                )
                return Number.isInteger(payable) ? payable : payable.toFixed(2)
              })()}
            </p>
          </Modal.Body>

          {/* Buttons */}
          <Modal.Footer>
            <Button variant="danger" onClick={() => setOpenPayment(false)}>
              Close
            </Button>
            <Button variant="success" onClick={handlePay}>
              Receive Now
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {showCancelModal && selectedStudent && feesToCancelIds.length > 0 && (
        <Modal
          size="lg"
          show={showCancelModal}
          onHide={() => {
            if (!isCancelling) {
              setShowCancelModal(false)
              setFeesToCancelIds([])
            }
          }}
          centered
        >
          <Modal.Header closeButton 
        closeVariant="white"
        className="bg-danger text-white">
            <Modal.Title
              className="text-white fw-bold"
              style={{ letterSpacing: '1px' }}
            >
              Confirm Cancellation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-2 fw-semibold" style={{ letterSpacing: '2px' }}>
              Are you sure you want to cancel{' '}
              {feesToCancelIds.length === 1 ? 'this fee payment' : `these ${feesToCancelIds.length} fee payments`} for: <br />
              <div>
                <br />
                <strong>Student:</strong>
                <span className="fw-semibold">
                  {' '}
                  {selectedStudentNameByParams?.name?.toUpperCase() ||
                    selectedStudentName?.toUpperCase() ||
                    '-'}
                </span>
                <br />
                {feesToCancelIds.length === 1 ? (
                  <>
                    <strong>Fees Name:</strong>
                    <span className="fw-semibold">
                      {' '}
                      {feesToCancelDetails[0]?.fees_name?.toUpperCase() || '-'}
                    </span>
                    <br />
                    <span style={{ letterSpacing: '2px' }}>
                      <strong className="mt-2 ">Amount:</strong>
                      <span className="text-danger fw-bold">
                        {' '}
                        ₹ {feesToCancelDetails[0]?.amount || 'N/A'}
                      </span>{' '}
                    </span>
                  </>
                ) : (
                  <>
                    <strong>Fees:</strong>
                    <ul className="mt-2 mb-0">
                      {feesToCancelDetails.map((fee) => (
                        <li key={fee.id} className="fw-semibold">
                          {fee.fees_name?.toUpperCase() || '-'} —{' '}
                          <span className="text-danger">₹ {fee.amount || 'N/A'}</span>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </p>
            <hr />
            <p
              style={{
                color: blinkColor,
                marginTop: '5px',
                marginBottom: '10px',
                letterSpacing: '2px',
              }}
            >
              Once cancelled, {feesToCancelIds.length === 1 ? 'this fee record' : 'these fee records'} will no longer be visible or
              available for further actions.
            </p>
            <Modal.Footer>
              <Button
                variant="danger"
                onClick={() => {
                  setShowCancelModal(false)
                  setFeesToCancelIds([])
                }}
                disabled={isCancelling}
              >
                Close
              </Button>
              <Button
                variant="success"
                disabled={isCancelling}
                onClick={handleConfirmCancel}
              >
                {isCancelling ? 'Cancelling...' : 'Confirm Cancel'}
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      )}

      <Modal
        show={openMultiplePayment}
        onHide={() => {
          if (!isSubmittingMultiple) {
            setOpenMultiplePayment(false)
          }
        }}
        centered
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="text-white"
          style={{ backgroundColor: '#223843' }}
        >
          <Modal.Title>
            💰 Take Multiple Fees ({selectedFeeIds.length})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <strong>Student:</strong>{' '}
            {selectedStudentNameByParams?.name?.toUpperCase() ||
              selectedStudentName?.toUpperCase() ||
              '-'}
            <ul className="mt-2 mb-0">
              {selectedFeesForMultiple.map((fee) => (
                <li key={fee.id} className="fw-semibold">
                  {fee.fees_name?.toUpperCase() || '-'} — ₹ {fee.amount || 'N/A'}
                </li>
              ))}
            </ul>
          </div>
          <Row className="g-3">
            <Col xs={12}>
              <Form.Group>
                <Form.Label>Payment Method</Form.Label>
                <Form.Select
                  name="payment_method"
                  value={multiplePaymentData.payment_method}
                  onChange={multiplePaymentInputHandler}
                  required
                >
                  <option value="">Select</option>
                  <option value="cash">Cash</option>
                  <option value="online">Online</option>
                  <option value="cheque">Cheque</option>
                  <option value="split">Split Payment</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col xs={12}>
              <Form.Group>
                <Form.Label>
                  {multiplePaymentData.payment_method === 'online'
                    ? 'Transaction ID'
                    : multiplePaymentData.payment_method === 'cheque'
                    ? 'Cheque ID'
                    : 'Transaction / Cheque ID'}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={
                    multiplePaymentData.payment_method === 'online'
                      ? 'Enter Transaction ID'
                      : multiplePaymentData.payment_method === 'cheque'
                      ? 'Enter Cheque ID'
                      : multiplePaymentData.payment_method === 'split'
                      ? 'Enter Transaction ID'
                      : 'Select a payment method first'
                  }
                  name="transaction_id"
                  value={multiplePaymentData.transaction_id}
                  onChange={multiplePaymentInputHandler}
                  disabled={
                    multiplePaymentData.payment_method !== 'online' &&
                    multiplePaymentData.payment_method !== 'cheque' &&
                    multiplePaymentData.payment_method !== 'split'
                  }
                />
              </Form.Group>
            </Col>

            <Col xs={12}>
              <Form.Group>
                <Form.Label>Transaction Amount</Form.Label>
                <Form.Control
                  type="text"
                  name="transaction_amount"
                  value={multiplePaymentData.transaction_amount}
                  onChange={multiplePaymentInputHandler}
                  disabled
                />
              </Form.Group>
            </Col>

            {multiplePaymentData.payment_method === 'split' && (
              <>
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>Enter Online Amount</Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.01"
                      name="online"
                      value={multiplePaymentData.online}
                      onChange={multiplePaymentInputHandler}
                      placeholder="Enter Online Amount"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>Enter Cash Amount</Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.01"
                      name="cash"
                      value={multiplePaymentData.cash}
                      onChange={multiplePaymentInputHandler}
                      placeholder="Enter Cash Amount"
                    />
                  </Form.Group>
                </Col>
              </>
            )}

            <Col xs={12}>
              <Form.Group>
                <Form.Label>Discount</Form.Label>
                <Form.Control
                  type="text"
                  name="discount"
                  value={multiplePaymentData.discount}
                  onChange={multiplePaymentInputHandler}
                />
                <Form.Text
                  className="d-block mt-1"
                  style={{ fontSize: '12px', color: '#6b7280', lineHeight: 1.4 }}
                >
                  {(() => {
                    const feeCount = selectedFeesForMultiple.length
                    const enteredDiscount = Number(multiplePaymentData.discount)
                    if (
                      !feeCount ||
                      !Number.isFinite(enteredDiscount) ||
                      enteredDiscount <= 0
                    ) {
                      return 'The entered discount will be split equally and applied on each fee.'
                    }
                    const perFee =
                      Math.round((enteredDiscount / feeCount) * 100) / 100
                    const amountLabel = Number.isInteger(perFee)
                      ? String(perFee)
                      : perFee.toFixed(2)
                    return `The entered discount (₹${amountLabel}) will be applied on each fee.`
                  })()}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col xs={12}>
              <Form.Group>
                <Form.Label>Transaction Date</Form.Label>
                <Form.Control
                  type="date"
                  name="transaction_date"
                  value={multiplePaymentData.transaction_date}
                  onChange={multiplePaymentInputHandler}
                />
              </Form.Group>
            </Col>
          </Row>
          <p
            className="fw-bold"
            style={{
              color: blinkColor,
              marginTop: '5px',
              marginBottom: '-5px',
              letterSpacing: '2px',
            }}
            >
            Please ensure to collect money: ₹
            {(() => {
              const total = Number(multiplePaymentData.transaction_amount) || 0
              const discount = Number(multiplePaymentData.discount) || 0
              const payable = Math.max(
                0,
                Math.round((total - discount) * 100) / 100,
              )
              return Number.isInteger(payable) ? payable : payable.toFixed(2)
            })()}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            disabled={isSubmittingMultiple}
            onClick={() => setOpenMultiplePayment(false)}
          >
            Close
          </Button>
          <Button
            variant="success"
            disabled={isSubmittingMultiple}
            onClick={handlePayMultiple}
          >
            {isSubmittingMultiple ? 'Receiving...' : 'Receive Now'}
          </Button>
        </Modal.Footer>
      </Modal>
        </div>
    </>
  )
}
